import React from 'react';
import styled from 'styled-components';
import loadingGif from 'assets/loading.gif';

const StyledDiv = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    width: 30em;
    height: 18em;
    margin-top: -9em;
    margin-left: -15em;
    justify-content: center;
    display: grid;
`;

export default function () {
    return (
        <StyledDiv>
            <img src={loadingGif} alt='Loading...'/>
        </StyledDiv>
    );
}



// WEBPACK FOOTER //
// ./src/components/atoms/LoadingDiv.js